import { AccountSettings, Card } from "@aws-amplify/ui-react";
import AuthService from "../../service/authService";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { Dialog } from "@progress/kendo-react-dialogs";
import { Alert } from "@mikros/shared-ui";
import { FormattedMessage, useIntl } from "react-intl";

export function ResetPassword() {
  const intl = useIntl();
  const [successPasswordChange, setSuccessPasswordChange] =
    useState<boolean>(false);
  const [logOutSuccess, setlogOutSuccess] = useState<boolean>(false);

  const toggleLogOutDialog = () => {
    setlogOutSuccess(!logOutSuccess);
  };
  const toggleSuccessPasswordChange = () => {
    setSuccessPasswordChange(!successPasswordChange);
  };
  const handleSuccess = () => {
    toggleSuccessPasswordChange();
  };

  const navigate = useNavigate();
  const logout = async () => {
    await AuthService.getInstance()
      .signOut()
      .then((response) => {
        // toast.success("Sign out successfully");
        toggleLogOutDialog();
        navigate("/");
      });
  };
  console.log("inside reset password file");
  return (
    <div>
      {logOutSuccess && (
        <Dialog className="confirmSuccessDialogue">
          <Alert
            description={intl.formatMessage({
              id: "appRoutes.logOut",
            })}
            buttonText={`${intl.formatMessage({
              id: "users.buttonText.Ok",
            })}`}
            icon={"successShape.png"}
            iconMsg={intl.formatMessage({
              id: "iconMsgSuccess",
            })}
            backgroundColor={"mk-bright-green"}
            onClick={() => {
              toggleLogOutDialog();
            }}
          />
        </Dialog>
      )}
      {successPasswordChange && (
        <Dialog className="confirmSuccessDialogue">
          <Alert
            description={intl.formatMessage({
              id: "resetPassword.successChange",
            })}
            buttonText={`${intl.formatMessage({
              id: "users.buttonText.Ok",
            })}`}
            icon={"/successShape.png"}
            iconMsg={intl.formatMessage({
              id: "iconMsgSuccess",
            })}
            backgroundColor={"mk-bright-green"}
            onClick={() => {
              toggleSuccessPasswordChange();
              logout();
            }}
          />
        </Dialog>
      )}
      <div className="text-mk-primary-bright text-xl font-bold">
        <FormattedMessage id="personal.resetPassword"></FormattedMessage>
      </div>
      <div className="mb-4"></div>
      <div>
        <Card width="400px" className="tableBackground custom-change-password">
          <AccountSettings.ChangePassword onSuccess={handleSuccess} />
        </Card>
      </div>
    </div>
  );
}
